import { render, staticRenderFns } from "./downed.vue?vue&type=template&id=0cc63a73&scoped=true&"
import script from "./downed.vue?vue&type=script&lang=ts&"
export * from "./downed.vue?vue&type=script&lang=ts&"
import style0 from "./downed.vue?vue&type=style&index=0&id=0cc63a73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc63a73",
  null
  
)

export default component.exports